import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Icon, Select } from '../components';
import { Button, Col, Row } from 'react-bootstrap';
import { useCreateRestrictionMutation } from '../../api/restrictionApiSlice';
import { useGetPublishersQuery } from '../../api/publisherApiSlice';

const NewRestrictionForm = ({restrictions, currentIndustry})=>{
  const { t } = useTranslation();
  const [newPublisher, setNewPublisher] = useState()
  const {data: publishers=[]} = useGetPublishersQuery()
  const publishersList = useMemo(() => {
    const restrictionsPublisherIds = restrictions.map((r) => (r.publisher_id))
    const filteredPublisher = publishers.filter(elt => !restrictionsPublisherIds.includes(elt.id))
    return filteredPublisher.map((p)=>({label: p.name ,value: p.id}))
  }, [publishers, restrictions])
  const [create] = useCreateRestrictionMutation()
  const industryId = useMemo( () => ( currentIndustry.id ? currentIndustry.id : 0 ), [currentIndustry])
  const onSubmit = ()=>{
    create({
      industryId: industryId,
      publisher_id: newPublisher,
    })
    setNewPublisher()
  }

  return (
    <Row style={{marginTop: "1em"}}>
      <Col>
        <Select
          options={publishersList}
          value={newPublisher}
          onChange={(e)=>(setNewPublisher(e))}
        />
      </Col>
      <Col xs={2}>
        <Button onClick={onSubmit} disabled={!newPublisher}>
          <Icon icon='plus' text={t("add")} />
        </Button>
      </Col>
    </Row>
  )
}

export default NewRestrictionForm;